<script setup lang="ts">
import VueFeather from 'vue-feather';

const props = defineProps<{
    isLoading: boolean
}>()
</script>

<template>
  <div class="container" :class="{ fadeout: !props.isLoading }">
    <img class="gotdah-logo logo" alt="GoTDAH logo" src="@/assets/logo-gotdah-horizontal.svg" />
    <div class="loader-container">
    <VueFeather class="loader" type="loader" />
    </div>

    <div>
        <p>Con el mecenazgo de:</p>
        <img class="barrie-logo logo" alt="Fundación Barrié logo" src="@/assets/logo_barrie.png" />
    </div>
  </div>
</template>

<style scoped>
.container {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: white;
    color: black;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    text-align: center;
}

.fadeout {
  animation: fadeout 0.5s forwards;
}

.logo {
    max-width: 100%;
    width: 300px;
    margin: 20px;
}

.gotdah-logo, .loader-container {
    flex-grow: 2;
}
.ingada-logo {
    width: 200px;
}

.loader {
    width: 50px;
    color: var(--main-color);
    animation: rotate 3s linear infinite;
}

@keyframes fadeout {
  to {
    opacity: 0;
    visibility: hidden;
  }
}

@keyframes rotate {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}

</style>
